<div class="text-box-container">
  <div class="question-header">
    <h6
      class="question-title"
      [style.font-size]="questionnaire?.mainContentTemplate?.questionStyle?.fontSize + 'px'"
      [style.font-family]="questionnaire?.mainContentTemplate?.questionStyle?.fontFamily"
      [style.font-weight]="questionnaire?.mainContentTemplate?.questionStyle?.boldStyle"
      [style.color]="questionnaire?.mainContentTemplate?.questionStyle?.fontColor"
    >
      {{ questionNumber }}. {{ question?.question || 'Untitled Question' | titlecase }}
      @if (question?.required) {
      <span
        [style.font-size]="'18px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.errorMessageStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontColor"
        >*</span
      >
      }
    </h6>
  </div>

  <div class="question-content-dropdown">
    <div class="dropdown-container">
      <div
        class="dropdown-header"
        [class.is-invalid]="isInvalid"
        [class.disabled]="disabled"
        (click)="toggleDropdown()"
      >
        @if(selectedOption) {
        <span>{{ selectedOption.label | titlecase }}</span>
        }@else {
        <span class="placeholder">Select your option</span>
        }
        <i class="bi bi-chevron-down dropdown-icon"></i>
      </div>

      @if(dropdownOpen) {
      <div class="dropdown-list">
        @if(allowSearch) {
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (input)="onSearchChange()"
          class="search-input"
          placeholder="Search..."
        />
        } @if(noResults) {
        <div class="no-results">No results found</div>
        } @for(option of filteredOptions; track option.value) {
        <div
          class="dropdown-option"
          [class.selected]="selectedOption?.value === option.value"
          (click)="selectOption(option)"
        >
          {{ option.label | titlecase }}
        </div>
        }
      </div>
      }
    </div>
    <!-- @if(isInvalid && errorMessage) {
          <div class="error-message">
            {{ errorMessage }}
          </div>
        } -->
  </div>

  @if (isOthersSelected()) {
  <div class="others-input-container">
    <input
      type="text"
      class="others-input"
      [ngModel]="othersText"
      [disabled]="disabled"
      placeholder="Please specify"
      (ngModelChange)="onOthersTextChange($event)"
      (blur)="onOthersInputBlur()"
    />
  </div>
  }
</div>
